import { useMedia } from 'react-use';
import { useMemo } from 'react';

export const useResponsiveGrid = (products: any, gridType: string = 'wide') => {
  const isMobile = useMedia('(max-width: 767px)', false);
  const isTablet = useMedia('(min-width: 1025px) and (max-width: 1440px)', false);

  return useMemo(() => {
    let gridProductCount = gridType === 'narrow' ? 2 : 4;

    if (isMobile) {
      gridProductCount = gridType === 'narrow' ? 1 : 2;
    } else if (isTablet) {
      gridProductCount = gridType === 'narrow' ? 4 : 8;
    }

    return products?.slice(0, gridProductCount) || [];
  }, [products, gridType, isMobile, isTablet]);
};
